import factory from './factory'

export default {
  filterByRegion (state, value) {
    if (value === null || value === 'all') {
      state.filtered = factory.ordered
    } else {
      state.filtered = factory.filterByRegion(value)
    }
    //state.appliedFilters = factory.appliedFilters
  },
  filterByProvider (state, value) {
    if (value === null || value === 'all') {
      state.filtered = factory.ordered
    } else {
      state.filtered = factory.filterByProvider(value)
    }
    //state.appliedFilters = factory.appliedFilters
  },
  filterByCountry (state, value) {
    if (value === null || value === 'all') {
      state.filtered = factory.ordered
    } else {
      state.filtered = factory.filterByCountry(value)
    }
    //state.appliedFilters = factory.appliedFilters
  }  
}
